import { render, staticRenderFns } from "./game-course-option1.vue?vue&type=template&id=3f76b240&scoped=true"
import script from "./game-course-option1.vue?vue&type=script&lang=js"
export * from "./game-course-option1.vue?vue&type=script&lang=js"
import style0 from "./game-course-option1.vue?vue&type=style&index=0&id=3f76b240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f76b240",
  null
  
)

export default component.exports